import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CampaignBanner } from 'src/app/api/api-campaigns.service.generated';
import { BannerImage, CampaignBannerImageComponent } from '../campaign-banner-image/campaign-banner-image.component';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from "wecheer-common";
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
  selector: 'app-staff-referral-campaign-banner',
  templateUrl: './staff-referral-campaign-banner.component.html',
  styleUrls: ['./staff-referral-campaign-banner.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => StaffReferralCampaignBannerComponent),
    multi: true
  }],
  imports: [
    CampaignBannerImageComponent,
    ButtonComponent,
    MatIconModule,
    FlexLayoutModule
  ]
})
export class StaffReferralCampaignBannerComponent implements ControlValueAccessor {

  @Input() staffReferralBanners: BannerImage[] = [];
  @Input() editable: boolean = true;
  @Output() mainReferralBannerChanged = new EventEmitter<BannerImage[]>();

  maxFileSize: number = 2 * 1024 * 1024;

  constructor() {
  }

  /// ControlValueAccessor-------------------
  @Input('value') _value;
  onChange: any = () => { };
  onTouched: any = () => { };
  get value(): CampaignBanner {
    return this._value;
  }
  set value(o: CampaignBanner) {
    this._value = o;

    this.staffReferralBanners = StaffReferralCampaignBannerComponent.setBanners(o);

    this.onChange(o);
    this.onTouched();
  }


  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(_isDisabled: boolean): void {
  }
  /// ControlValueAccessor------------------

  notifyFormChanged() {
    const o = StaffReferralCampaignBannerComponent.getBanners(this.staffReferralBanners);
    this._value = o;
    this.onChange(o);
    this.onTouched();
  }

  onAdd() {
    this.staffReferralBanners.push(new BannerImage());
    this.notifyFormChanged();
  }

  onRemove(b: BannerImage) {
    const ix = this.staffReferralBanners.indexOf(b);
    this.staffReferralBanners.splice(ix, 1);
    if (ix === 0) {
      this.mainReferralBannerChanged.emit(this.staffReferralBanners);
    }

    this.notifyFormChanged();
  }

  onBannerUploaded(banner: any) {
    const ix = this.staffReferralBanners.indexOf(banner);
    if (ix === 0) {
      this.mainReferralBannerChanged.emit(this.staffReferralBanners);
    }

    this.notifyFormChanged();
  }

  public setMainBanner(banner: BannerImage) {
    if (this.staffReferralBanners.length === 0)
      this.staffReferralBanners.push(new BannerImage());

    this.staffReferralBanners[0] = banner;

    this.notifyFormChanged();
  }

  public static setBanners(banner: CampaignBanner) {
    if (!banner)
      return;

    const banners = [];

    if (banner.url1) banners.push(new BannerImage({ photoUrl: banner.url1 }));
    if (banner.url2) banners.push(new BannerImage({ photoUrl: banner.url2 }));
    if (banner.url3) banners.push(new BannerImage({ photoUrl: banner.url3 }));
    if (banner.url4) banners.push(new BannerImage({ photoUrl: banner.url4 }));
    if (banner.url5) banners.push(new BannerImage({ photoUrl: banner.url5 }));

    return banners;
  }
  public static getBanners(banners): CampaignBanner {
    if (banners.length === 0)
      return undefined

    return new CampaignBanner({
      url1: banners.length < 1 ? undefined : banners[0].photoUrl,
      key1: banners.length < 1 ? undefined : banners[0].uploadKey,

      url2: banners.length < 2 ? undefined : banners[1].photoUrl,
      key2: banners.length < 2 ? undefined : banners[1].uploadKey,

      url3: banners.length < 3 ? undefined : banners[2].photoUrl,
      key3: banners.length < 3 ? undefined : banners[2].uploadKey,

      url4: banners.length < 4 ? undefined : banners[3].photoUrl,
      key4: banners.length < 4 ? undefined : banners[3].uploadKey,

      url5: banners.length < 5 ? undefined : banners[4].photoUrl,
      key5: banners.length < 5 ? undefined : banners[4].uploadKey
    });
  }

}